import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import * as Sentry from '@sentry/vue';

import { ToastService } from 'primevue';
import PrimeVue from 'primevue/config';
import Dialog from 'primevue/dialog';
import Tooltip from 'primevue/tooltip';
import { registerSW } from 'virtual:pwa-register';
import { createApp } from 'vue';
import { VueFire, VueFireAuth } from 'vuefire';
import App from './App.vue';
import { firebaseApp } from './firebase';
import { router } from './router';

import './style.css';

registerSW({ immediate: true });

const app = createApp(App);

Sentry.init({
  enabled: !import.meta.env.DEV,
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  release: import.meta.env.VITE_VERSION,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['app.shotmetrics-ai.com'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{green.50}',
      100: '{green.100}',
      200: '{green.200}',
      300: '{green.300}',
      400: '{green.400}',
      500: '{green.500}',
      600: '{green.600}',
      700: '{green.700}',
      800: '{green.800}',
      900: '{green.900}',
      950: '{green.950}',
    },
  },
});
// Configure PrimeVue
app.use(PrimeVue, {
  theme: {
    preset: MyPreset,
    options: {
      prefix: 'p',
      darkModeSelector: 'system',
      cssLayer: false,
    },
  },
});

// Configure Firebase
app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
});

// Add services
app.use(ToastService);

app.use(router);

app.directive('tooltip', Tooltip);
app.component('Dialog', Dialog);

app.mount('#app');

// eslint-disable-next-line no-console
console.log('[*] App startup complete for: ', import.meta.env.VITE_VERSION);
